import React, { useState, useEffect, useContext } from "react";
import { Redirect, Route } from "react-router-dom";
import { getDomainFromToken, isAuthenticated } from "../commons/Auth/auth";
import { hasPermission } from "../commons/Permissions/PermissionsHook";
import { UserContext } from "../context/UserContext";

const ServiceProviderRoutes = ({ path, component: Component, ...rest }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);
  const [isAuthenticatedState, setIsAuthenticatedState] = useState(false);
  const userData = isAuthenticated();
  const user = useContext(UserContext);
  const routeName = window.location.pathname;
  const domain = getDomainFromToken();
  useEffect(() => {
    if (userData) {
      setIsAuthenticatedState(true);
    } else {
      setIsAuthenticatedState(false);
    }
  }, []);

  useEffect(() => {
    const role = isAuthenticated()?.role;
    // An employee's permissions arrive with UserContext. Deciding before that bounced every
    // direct page load (or refresh) to /user.
    if (role === 1 && !user) return;
    const permissions = user?.permissions;
    if (!permissions && role === 2) {
      setHasAccess(true);
    } else if (routeName?.split("/")[2]?.toLowerCase() === "profile") {
      // Everyone may open their own profile, also an employee without a role.
      setHasAccess(true);
    } else if (Array.isArray(permissions)) {
      let module = routeName == "/user" ? "Dashboard" : routeName?.split("/")[2];
      // A board's page (/user/tickets/:id) belongs to the Boards module; there is no "tickets"
      // permission, so without this an employee could list boards but not open one.
      if (module?.toLowerCase() === "tickets") module = "Boards";
      // Offers (and "Find jobs" under them) belong to the Invoices module, as in the sidebar and
      // on the server; there is no "offers" permission, so employees could never open them.
      if (module?.toLowerCase() === "offers") module = "Invoices";
      const permissionGranted = hasPermission(permissions, module, "Read", true);
      setHasAccess(permissionGranted);
    } else {
      setHasAccess(false);
    }
    setIsLoading(false);
  }, [routeName, user]);

  if (isLoading) return null;

  const getLoginRedirect = () => {
    if (domain) {
      try {
        const url = new URL(domain);
        return `${url.origin}/login`;
      } catch {
        return "/login";
      }
    }
    return "/login";
  };

  return (
    !isLoading && (
      <Route
        {...rest}
        render={props =>
          isAuthenticatedState ? (
            hasAccess ? (
              <Component {...props} />
            ) : (
              <Redirect to={{ pathname: "/user" }} />
            )
          ) : (
            <Redirect to={{ pathname: getLoginRedirect() }} />
          )
        }
      />
    )
  );
};

export default ServiceProviderRoutes;
